export const eLearningNameToId = (name: string) => {
  let result = name.trim().toLowerCase();
  result = result.normalize("NFD").replace(/[\u0300-\u036f'`’]/g, ""); // accents
  result = result.split(' ').join('-');
  return result;
};

export const makeUniqueELearningId = (baseSlug: string, existingIds: string[]): string => {
  const taken = new Set(existingIds);
  if (!taken.has(baseSlug)) return baseSlug;
  let suffix = 2;
  while (taken.has(`${baseSlug}-${suffix}`)) suffix++;
  return `${baseSlug}-${suffix}`;
};
